module.exports = {"path":"/404.html","body":"<h1>Irutrm</h1>\n<p>Diese Seite gibt es nicht. Vielleicht beim nächsten Mal. Die Startseite funktioniert aber noch ;-)</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 1170
// module chunks = 0